// This file was automatically generated from profile.html.
// Please don't edit this file by hand.

goog.provide('el8.template.passport.profile');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.passport.profile.meds');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.ptdata.ptAllergies');
goog.require('el8.template.ptdata.ptImmunizationDeclines');
goog.require('el8.template.ptdata.ptImmunizations');
goog.require('el8.template.ptdata.ptIntolerances');
goog.require('el8.template.ptdata.ptProblems');
goog.require('el8.template.ptdata.ptProviders');
goog.require('el8.template.ptdata.smokingStatuses');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.header = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8ScreenReaderOnly">Profile Contents</h1><p class="el8FaxPrintProfileText">Share your Profile with other medical providers to ensure continuity of care.</p><div class="el8Spacer el8AlignCenter"><button class="pane-nav-trigger el8HeaderButton el8ProfileButton ml10" id="export-trigger" data-name="export" tabindex="0"><span class="el8DownloadIcon"></span>Download My Data</button></a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.notDocumented = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Not yet documented');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.noneDocumented = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('None documented');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MainContainer"><div class="el8Spacer el8ProfileButtonContainer"><button class="el8HeaderButton el8ProfileButton" id="fax-profile-trigger" tabindex="0"><span class="el8FaxIcon"></span>Fax Profile</button><button class="el8HeaderButton el8ProfileButton ml10" id="print-profile-trigger" tabindex="0"><span class="el8PrintIcon"></span>Print Profile</button></div><ul class="el8BioWrapper clearfix"><li class="el8SpanWrapper"><div class="el8BioPicture"><h1>');
  el8.template.ptdata.patients.patientFacingName(opt_data.patient, output);
  output.append('</h1></div></li><li class="el8SpanWrapper"><table class="el8BioDemographics" cellpadding="0" cellspacing="0"><tr><td class="el8AlignRight">Date Of Birth:</td><td class="el8EmphasizedText">', soy.$$escapeHtml(opt_data.patient.dob), '</td></tr><tr><td class="el8AlignRight">Primary Provider:</td><td class="el8EmphasizedText">', soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.fullName : ''), '</td></tr><tr><td class="el8AlignRight">Last Appointment:</td><td class="el8EmphasizedText">', (opt_data.lastSeenDate) ? (soy.$$escapeHtml(opt_data.lastSeenDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.lastSeenDate)) : '') : 'None', '</td></tr><tr><td class="el8AlignRight">Next Appointment:</td><td class="el8EmphasizedText">', (opt_data.nextApptDate) ? (soy.$$escapeHtml(opt_data.nextApptDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.nextApptDate)) : '') : 'None', '</td></tr></table></li></ul><h2 class="mthalfem">Allergies</h2>');
  if (opt_data.ptAllergies.items.length) {
    output.append('<ul class="el8ProfileSectionContainer el8HighlightWrap">');
    var paList513 = opt_data.ptAllergies.items;
    var paListLen513 = paList513.length;
    for (var paIndex513 = 0; paIndex513 < paListLen513; paIndex513++) {
      var paData513 = paList513[paIndex513];
      output.append('<li class="el8ItemText">');
      el8.template.ptdata.ptAllergies.summary(paData513, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else {
    if (opt_data.ptAllergies.isDocumented) {
      output.append('<p class="el8ProfileSectionContainer">');
      el8.template.ptdata.ptAllergies.documentedAsNonePatientSummary(null, output);
      output.append('</p>');
    } else {
      output.append('<p class="el8ProfileSectionContainer">');
      el8.template.passport.profile.notDocumented(null, output);
      output.append('</p>');
    }
  }
  output.append('<h2>Drug Intolerances</h2>');
  if (opt_data.ptIntols.items.length) {
    output.append('<ul class="el8ProfileSectionContainer">');
    var piList533 = opt_data.ptIntols.items;
    var piListLen533 = piList533.length;
    for (var piIndex533 = 0; piIndex533 < piListLen533; piIndex533++) {
      var piData533 = piList533[piIndex533];
      output.append('<li class="el8ItemText">');
      el8.template.ptdata.ptIntolerances.summary(piData533, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else {
    if (opt_data.ptIntols.isDocumented) {
      output.append('<p class="el8ProfileSectionContainer">');
      el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
      output.append('</p>');
    } else {
      output.append('<p class="el8ProfileSectionContainer">');
      el8.template.passport.profile.notDocumented(null, output);
      output.append('</p>');
    }
  }
  if (opt_data.ptProblems) {
    output.append('<h2>Problem List</h2>');
    if (opt_data.ptProblems.items.length) {
      output.append('<ul class="el8ProfileSectionContainer">');
      var ppList555 = opt_data.ptProblems.items;
      var ppListLen555 = ppList555.length;
      for (var ppIndex555 = 0; ppIndex555 < ppListLen555; ppIndex555++) {
        var ppData555 = ppList555[ppIndex555];
        output.append('<li class="el8ItemText el8ItemWithDateYr"><div class="el8DateYr">', soy.$$escapeHtml(ppData555.year), '</div>');
        el8.template.ptdata.ptProblems.summaryNoYear(ppData555, output);
        output.append('</li>');
      }
      output.append('</ul>');
    } else {
      if (opt_data.ptProblems.isDocumented) {
        output.append('<p class="el8ProfileSectionContainer">');
        el8.template.ptdata.ptProblems.documentedAsNoneSummary(null, output);
        output.append('</p>');
      } else {
        output.append('<p class="el8ProfileSectionContainer">');
        el8.template.passport.profile.notDocumented(null, output);
        output.append('</p>');
      }
    }
  }
  if (opt_data.historyItems) {
    output.append('<h2>History</h2>');
    if (! opt_data.historyItems.past.items.length && ! opt_data.historyItems.surgical.items.length && ! opt_data.historyItems.family.items.length && ! opt_data.historyItems.social.items.length && ! opt_data.historyItems.habits.items.length && ! opt_data.historyItems.diet.items.length && ! opt_data.historyItems.exercise.items.length && ! opt_data.historyItems.cognitive.items.length && ! opt_data.historyItems.functional.items.length && ! opt_data.currSmokingStatus && ! opt_data.familyRelationships.length) {
      output.append('<p class="el8ProfileSectionContainer">');
      el8.template.passport.profile.noneDocumented(null, output);
      output.append('</p>');
    } else {
      output.append('<ul class="el8ProfileSectionContainer">');
      el8.template.passport.profile.rowsList({sectionTitle: 'Past Medical History', itemsList: opt_data.historyItems.past.items}, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Past Surgical History', itemsList: opt_data.historyItems.surgical.items}, output);
      el8.template.passport.profile.familyHistoryList(opt_data, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Social History', itemsList: opt_data.historyItems.social.items}, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Psychological', itemsList: opt_data.historyItems.psychological.items}, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Cognitive', itemsList: opt_data.historyItems.cognitive.items}, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Functional', itemsList: opt_data.historyItems.functional.items}, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Habits', itemsList: opt_data.historyItems.habits.items}, output);
      if (opt_data.currSmokingStatus) {
        output.append('<li class="el8ItemText">Cigs: ');
        el8.template.ptdata.smokingStatuses.summary(opt_data.currSmokingStatus, output);
        output.append('</li>');
      }
      el8.template.passport.profile.rowsList({sectionTitle: 'Diet', itemsList: opt_data.historyItems.diet.items}, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Exercise', itemsList: opt_data.historyItems.exercise.items}, output);
      el8.template.passport.profile.rowsList({sectionTitle: 'Health Maintenance', itemsList: opt_data.historyItems.maintenance.items}, output);
      output.append('</ul>');
    }
  }
  output.append('<h2>Permanent Rx Meds</h2>');
  if (opt_data.permRxThreads.length) {
    output.append('<ul class="el8ProfileSectionContainer">');
    el8.template.passport.profile.meds.permList({threads: opt_data.permRxThreads}, output);
    output.append('</ul>');
  } else {
    output.append('<p class="el8ProfileSectionContainer">');
    el8.template.passport.profile.noneDocumented(null, output);
    output.append('</p>');
  }
  output.append('<h2>Permanent OTC Meds</h2>');
  if (opt_data.permOtcThreads.length) {
    output.append('<ul class="el8ProfileSectionContainer">');
    el8.template.passport.profile.meds.permList({threads: opt_data.permOtcThreads}, output);
    output.append('</ul>');
  } else {
    output.append('<p class="el8ProfileSectionContainer">');
    el8.template.passport.profile.noneDocumented(null, output);
    output.append('</p>');
  }
  output.append('<h2>Immunizations</h2>');
  if (opt_data.ptImmunizations.items.length || opt_data.ptImmunizationDeclines.items.length || opt_data.historyItems && opt_data.historyItems.immunization.items.length) {
    output.append('<ul class="el8ProfileSectionContainer">');
    var itemList646 = opt_data.ptImmunizations.items;
    var itemListLen646 = itemList646.length;
    for (var itemIndex646 = 0; itemIndex646 < itemListLen646; itemIndex646++) {
      var itemData646 = itemList646[itemIndex646];
      output.append('<li class="el8ItemText">');
      el8.template.ptdata.ptImmunizations.summary(itemData646, output);
      output.append('</li>');
    }
    var itemList651 = opt_data.ptImmunizationDeclines.items;
    var itemListLen651 = itemList651.length;
    for (var itemIndex651 = 0; itemIndex651 < itemListLen651; itemIndex651++) {
      var itemData651 = itemList651[itemIndex651];
      output.append('<li class="el8ItemText">');
      el8.template.ptdata.ptImmunizationDeclines.summary(itemData651, output);
      output.append('</li>');
    }
    if (opt_data.historyItems) {
      el8.template.passport.profile.bulletedListContent({itemsList: opt_data.historyItems.immunization.items}, output);
    }
    output.append('</ul>');
  } else {
    output.append('<p class="el8ProfileSectionContainer">');
    el8.template.passport.profile.noneDocumented(null, output);
    output.append('</p>');
  }
  if (opt_data.legalReportSummaries || opt_data.historyItems) {
    output.append('<h2>Legal</h2>');
    if (opt_data.legalReportSummaries.length || opt_data.historyItems.legal.items.length) {
      output.append('<ul class="el8ProfileSectionContainer">');
      var itemList671 = opt_data.legalReportSummaries;
      var itemListLen671 = itemList671.length;
      for (var itemIndex671 = 0; itemIndex671 < itemListLen671; itemIndex671++) {
        var itemData671 = itemList671[itemIndex671];
        output.append('<li class="el8ItemText">', soy.$$escapeHtml(itemData671), '</li>');
      }
      if (opt_data.historyItems) {
        el8.template.passport.profile.bulletedListContent({itemsList: opt_data.historyItems.legal.items}, output);
      }
      output.append('</ul>');
    } else {
      output.append('<p class="el8ProfileSectionContainer">');
      el8.template.passport.profile.noneDocumented(null, output);
      output.append('</p>');
    }
  }
  if (opt_data.mainProviders) {
    output.append('<h2>Consulting Physicians</h2>');
    if (opt_data.mainProviders.length) {
      output.append('<ul class="el8ProfileSectionContainer">');
      var itemList691 = opt_data.mainProviders;
      var itemListLen691 = itemList691.length;
      for (var itemIndex691 = 0; itemIndex691 < itemListLen691; itemIndex691++) {
        var itemData691 = itemList691[itemIndex691];
        output.append('<li class="el8ItemText">');
        el8.template.ptdata.ptProviders.summary(itemData691, output);
        output.append('</li>');
      }
      output.append('</ul>');
    } else {
      output.append('<p class="el8ProfileSectionContainer">');
      el8.template.passport.profile.noneDocumented(null, output);
      output.append('</p>');
    }
  }
  output.append((opt_data.patient.primaryInsurance && opt_data.patient.primaryInsurance.isNonEmpty || opt_data.patient.secondaryInsurance && opt_data.patient.secondaryInsurance.isNonEmpty) ? '<h2>Insurance Information</h2><ul class="el8ProfileSectionContainer">' + ((opt_data.patient.primaryInsurance.insuranceCompany) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Plan Name:</div>' + soy.$$escapeHtml(opt_data.patient.primaryInsurance.insuranceCompany.carrier) + ((opt_data.patient.primaryInsurance.insurancePlan) ? ' ' + soy.$$escapeHtml(opt_data.patient.primaryInsurance.insurancePlan.name) : '') + '</li>' : '') + ((opt_data.patient.primaryInsurance.groupId) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Group Name:</div>' + soy.$$escapeHtml(opt_data.patient.primaryInsurance.groupId) + '</li>' : '') + ((opt_data.patient.primaryInsurance.memberId) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Member No.:</div>' + soy.$$escapeHtml(opt_data.patient.primaryInsurance.memberId) + '</li>' : '') + ((opt_data.patient.secondaryInsurance.insuranceCompany) ? '<li class="el8ItemText el8ItemWithLabel1 mt20"><div class="el8Label1">Secondary Plan:</div>' + soy.$$escapeHtml(opt_data.patient.secondaryInsurance.insuranceCompany.carrier) + ((opt_data.patient.secondaryInsurance.insurancePlan) ? ' ' + soy.$$escapeHtml(opt_data.patient.secondaryInsurance.insurancePlan.name) : '') + '</li>' : '') + ((opt_data.patient.secondaryInsurance.groupId) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Group Name:</div>' + soy.$$escapeHtml(opt_data.patient.secondaryInsurance.groupId) + '</li>' : '') + ((opt_data.patient.secondaryInsurance.memberId) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Member No.:</div>' + soy.$$escapeHtml(opt_data.patient.secondaryInsurance.memberId) + '</li>' : '') + '</ul>' : '', (opt_data.patient.race != 1 && opt_data.patient.displayRace || opt_data.patient.ethnicity != 1 && opt_data.patient.displayEthnicity || opt_data.patient.preferredLanguageName) ? '<h2>Demographics</h2><ul class="el8ProfileSectionContainer">' + ((opt_data.patient.race != 1 && opt_data.patient.displayRace) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Race:</div>' + soy.$$escapeHtml(opt_data.patient.displayRace) + '</li>' : '') + ((opt_data.patient.ethnicity != 1 && opt_data.patient.displayEthnicity) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Ethnicity:</div>' + soy.$$escapeHtml(opt_data.patient.displayEthnicity) + '</li>' : '') + ((opt_data.patient.preferredLanguageName) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Pref. Language:</div>' + soy.$$escapeHtml(opt_data.patient.preferredLanguageName) + '</li>' : '') + '</ul>' : '', '<h2>Emergency Contact</h2>');
  if (opt_data.patient.nokFirstName || opt_data.patient.nokLastName || opt_data.patient.nokPhone) {
    output.append('<ul class="el8ProfileSectionContainer">', (opt_data.patient.nokFirstName || opt_data.patient.nokLastName) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Name:</div>' + soy.$$escapeHtml(opt_data.patient.nokFirstName ? opt_data.patient.nokFirstName : '') + ' ' + soy.$$escapeHtml(opt_data.patient.nokLastName ? opt_data.patient.nokLastName : '') + '</li>' : '', (opt_data.patient.nokRelationship) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Relationship:</div>' + soy.$$escapeHtml(opt_data.patient.nokRelationship) + '</li>' : '', (opt_data.patient.nokPhone) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Phone:</div>' + soy.$$escapeHtml(opt_data.patient.nokPhone) + '</li>' : '', (opt_data.patient.nokAddress || opt_data.patient.nokCity) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Address:</div>' + soy.$$escapeHtml(opt_data.patient.nokAddress ? opt_data.patient.nokAddress : '') + ((opt_data.patient.nokSuite) ? ', ' + soy.$$escapeHtml(opt_data.patient.nokSuite) : '') + '</li><li class="el8ItemText el8ItemWithLabel1">' + soy.$$escapeHtml(opt_data.patient.nokCity ? opt_data.patient.nokCity : '') + ', ' + soy.$$escapeHtml(opt_data.patient.nokState ? opt_data.patient.nokState : '') + ' ' + soy.$$escapeHtml(opt_data.patient.nokZip ? opt_data.patient.nokZip : '') + '</li>' : '', '</ul>');
  } else {
    output.append('<p class="el8ProfileSectionContainer">');
    el8.template.passport.profile.noneDocumented(null, output);
    output.append('</p>');
  }
  output.append('<h2>Provider Contact Information</h2><ul class="el8ProfileSectionContainer"><li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Physician:</div>', (opt_data.primaryPhysician) ? soy.$$escapeHtml(opt_data.primaryPhysician.fullName) : '', '</li>', (opt_data.primaryPhysician.address || opt_data.primaryPhysician.cityStateZip || opt_data.primaryPhysician.phone || opt_data.primaryPhysician.fax) ? '<li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Address:</div>' + soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.address : '') + '</li><li class="el8ItemText el8ItemWithLabel1">' + soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.cityStateZip : '') + '</li><li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Office:</div>' + soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.phone : '') + '</li><li class="el8ItemText el8ItemWithLabel1"><div class="el8Label1">Fax:</div>' + soy.$$escapeHtml(opt_data.primaryPhysician ? opt_data.primaryPhysician.fax : '') + '</li>' : '', '</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.familyHistoryList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.historyItems.family.items.length || opt_data.familyRelationships.length) {
    output.append('<li class="el8ItemHeader">Family History</li>');
    var relationshipList824 = opt_data.familyRelationships;
    var relationshipListLen824 = relationshipList824.length;
    for (var relationshipIndex824 = 0; relationshipIndex824 < relationshipListLen824; relationshipIndex824++) {
      var relationshipData824 = relationshipList824[relationshipIndex824];
      var itemList825 = relationshipData824.items;
      var itemListLen825 = itemList825.length;
      for (var itemIndex825 = 0; itemIndex825 < itemListLen825; itemIndex825++) {
        var itemData825 = itemList825[itemIndex825];
        output.append('<li class="el8ItemText">', soy.$$escapeHtml(relationshipData824.relationshipTypeName), ': ', soy.$$escapeHtml(itemData825.textOrCodeDescription), '</li>');
      }
    }
    var itemList833 = opt_data.historyItems.family.items;
    var itemListLen833 = itemList833.length;
    for (var itemIndex833 = 0; itemIndex833 < itemListLen833; itemIndex833++) {
      var itemData833 = itemList833[itemIndex833];
      output.append('<li class="el8ItemText">', soy.$$escapeHtml(itemData833.text), '</li>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.rowsList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.itemsList.length) {
    output.append('<li class="el8ItemHeader">', soy.$$escapeHtml(opt_data.sectionTitle), '</li>');
    el8.template.passport.profile.rowsListContent(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.rowsListContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList846 = opt_data.itemsList;
  var itemListLen846 = itemList846.length;
  for (var itemIndex846 = 0; itemIndex846 < itemListLen846; itemIndex846++) {
    var itemData846 = itemList846[itemIndex846];
    output.append((itemData846.modelClass == 'ClinicalFormCollection') ? '<li class="el8ItemText">' + soy.$$escapeHtml(itemData846.collectionSummary) + '</li>' : '<li class="el8ItemText">' + soy.$$escapeHtml(itemData846.text) + '</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.profile.bulletedListContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList858 = opt_data.itemsList;
  var itemListLen858 = itemList858.length;
  for (var itemIndex858 = 0; itemIndex858 < itemListLen858; itemIndex858++) {
    var itemData858 = itemList858[itemIndex858];
    output.append('<li class="el8ItemText">', soy.$$escapeHtml(itemData858.text), '</li>');
  }
  if (!opt_sb) return output.toString();
};
